import { INotificationFrequency } from "models/NotificationFrequencyModel";
import { BaseService } from "./base.service";

class NotificationFrequencyServiceInternal extends BaseService {
	getNotificationFrequencyList = async (): Promise<INotificationFrequency[]> =>
		this.callApi<INotificationFrequency[]>(
			`NotificationFrequency/GetNotificationFrequencyList`,
			"GET",
			undefined,
			undefined,
			undefined,
			undefined,
			false
		);

	getPerformanceEvaluationFrequencyList = async (): Promise<
		INotificationFrequency[]
	> =>
		this.callApi<INotificationFrequency[]>(
			`NotificationFrequency/GetPerformanceEvaluationFrequencyList`,
			"GET",
			undefined,
			undefined,
			undefined,
			undefined,
			false
		);
}

export const NotificationFrequencyService =
	new NotificationFrequencyServiceInternal();
